import React, { useState } from 'react';
import { ControlledConfirmDialog } from 'src/shared/components/confirm/ControlledConfirmDialog';
import type { ApiTokenSummary } from '../../state/api/engineApiTokensEngineSlice';

type RevokeTokenDialogProps = {
    token: ApiTokenSummary;
    onConfirm: () => Promise<void>;
    onCancel: () => void;
};

const RevokeTokenDialog = ({ token, onConfirm, onCancel }: RevokeTokenDialogProps) => {
    const [isConfirming, setIsConfirming] = useState(false);

    const handleConfirm = async () => {
        setIsConfirming(true);
        try {
            await onConfirm();
        } finally {
            setIsConfirming(false);
        }
    };

    const handleOpenChange = (open: boolean) => {
        if (!open) onCancel();
    };

    return (
        <ControlledConfirmDialog
            open={true}
            onOpenChange={handleOpenChange}
            variant='confirm'
            title={`Revoke "${token.name}"?`}
            description='This will immediately invalidate the token. Integrations using it will fail. This cannot be undone.'
            confirmLabel='Revoke'
            onConfirm={handleConfirm}
            isConfirming={isConfirming}
        />
    );
};

export default RevokeTokenDialog;
